import React from 'react';

import {
  history,
} from 'web-history';

import {
  Icon,
  Button,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';
import * as S from './styled';

type Props = {
  event: Object,
  onFinished: { (): void },
}

export default ({
  event,
  onFinished,
}: Props) => (
  <S.Navigation>
    <Flex align="center" spacing={10}>
      <S.A
        href="#"
        onClick={(e) => {
          e.preventDefault();
          history.goBack();
        }}
      >
        <Icon
          type="fas fa-chevron-left"
        />
      </S.A>
      <Text
        color="#9ea0a1"
        size="16px"
      >
        {event.workout_name}
      </Text>
    </Flex>
    <Flex align="center" spacing={10}>
      <S.Date>
        <Icon type="fas fa-calendar-day" />
        <span>
          {event.start}
        </span>
      </S.Date>
      <Flex align="center">
        <S.NavPrev
          to={`/events/${event.prev_id}/results`}
          style={{ cursor: event.prev_id ? 'pointer' : 'not-allowed' }}
          onClick={(e) => {
            if (!event.prev_id) {
              e.preventDefault();
            }
          }}
        >
          <Icon type="fas fa-chevron-left" />
        </S.NavPrev>
        <S.NavNext
          to={`/events/${event.next_id}/results`}
          style={{ cursor: event.next_id ? 'pointer' : 'not-allowed' }}
          onClick={(e) => {
            if (!event.next_id) {
              e.preventDefault();
            }
          }}
        >
          <Icon type="fas fa-chevron-right" />
        </S.NavNext>
      </Flex>
      <Button
        ghost
        appearance="primary"
        onClick={onFinished}
      >
        Finished
      </Button>
    </Flex>
  </S.Navigation>
);
